import React, { Component } from 'react';

import General from '../../../utils/General'

import {Bar} from 'react-chartjs-2';

export default class BarChart extends Component  {

  constructor(props){
    super(props);
    this.state = this._getState(props)
  }

  componentWillReceiveProps(nextProps){
    this.setState(this._getState(nextProps))
  }

  _getState(props){
    let labels = props.labels || props.data.map(point => "")
    return {
      data: this._getData(props.data, labels, props.color),
      minimal: props.minimal,
    }
  }

  _getData(data, labels, color){
    let dataset = data.map(entry => {
      return (
        {
          label: entry.label,
          borderColor: entry.borderColor,
          borderWidth: entry.borderWidth,
          backgroundColor: entry.backgroundColor,
          fill: this.props.backgroundColor != null,
          data: entry.data,
        }
      )
    })

    return  {
      labels,
      datasets: dataset
    }
  }

  render(){
    let {
      data,
      minimal
    } = this.state

    let options = { ...this.props.options }


    let props = {}

    return (
      <Bar
        { ...props }
        data={data}
        options={options}
      />
    )
  }
}

BarChart.defaultProps = {
  minimal: true,
  options: {
    title: {
      display: false,
    },
    tooltips: {
      enabled: true,
      intersect: false,
      mode: 'x',
      xPadding: 10,
      yPadding: 10,
      caretPadding: 10,
      backgroundColor: '#fff',
      titleFontSize: 15,
      titleFontColor: '#555555',
      titleSpacing: 3,
      titleAlign: 'center',
      bodyFontColor: '#55555',
      bodySpacing: 7,
      bodyAlign: 'center',
      borderWidth: 2,
      borderColor: '#e5e5e5',
      displayColors: true,
      callbacks: {
        label: function(tooltipItem, data) {
          var label = data.datasets[tooltipItem.datasetIndex].label || '';

          if (label) {
            label += ': ';
          }
          let value = Math.round(tooltipItem.yLabel * 100) / 100;
          value = Number(value).toLocaleString('en')
          label += value
          return label;
        }
      }
    },
    legend: {
      display: false,
      labels: {
        usePointStyle: false
      }
    },
    responsive: true,
    maintainAspectRatio: true,
    hover: {
      mode: 'index'
    },
    scales: {
      xAxes: [{
        barPercentage: 0.3,
        gridLines: false,
        scaleLabel: {
          display: true,
          labelString: ''
        },
        ticks: {
          padding: 10
        }
      }],
      yAxes: [{
        gridLines: false,
        scaleLabel: {
          display: true,
          labelString: ''
        },
        ticks: {
          beginAtZero: true,
          padding: 10,
          callback: function(label) {
            return (
              window.General.DefaultCurrency.symbol + label.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
            );
          }
        }
      }]
    },

    elements: {
      point: {
        radius: 4,
        borderWidth: 12
      },
    },

    layout: {
      padding: {
        right: 25,
      }
    }
  }
}

const styles = {
  container: {
    width: 100,
    height: 50
  },
  canvas: {
    display: 'block',
    width: 100,
    height: 50
  }
}
